import api from './axios';

export const loginApi = (data) => api.post('/auth/login/', data);
export const registerUserApi = (formData) =>
  api.post('/auth/register/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const registerPublisherApi = (formData) =>
  api.post('/auth/register/publisher/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const logoutApi = (refresh) => api.post('/auth/logout/', { refresh });
export const getProfileApi = () => api.get('/auth/profile/');
export const updateProfileApi = (data) => api.patch('/auth/profile/', data);
export const changePasswordApi = (data) => api.post('/auth/change-password/', data);
export const forgotPasswordApi = (data) => api.post('/auth/forgot-password/', data);
export const resetPasswordApi = (data) => api.post('/auth/reset-password/', data);

// All authenticated users — for filter dropdowns
export const getPublicPublishersApi = (params) => api.get('/auth/publishers/public/', { params });

// Admin — publisher management
export const getPublishersApi = (params) => api.get('/auth/publishers/', { params });
export const adminCreatePublisherApi = (formData) =>
  api.post('/auth/publishers/create/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const togglePublisherStatusApi = (id) => api.post(`/auth/publishers/${id}/toggle-status/`);
export const approvePublisherApi = (id, approve) =>
  api.post(`/auth/publishers/${id}/approve/`, { approve });
export const getPendingPublishersApi = () => api.get('/auth/publishers/pending/');
export const getUsersApi = (params) => api.get('/auth/users/', { params });
export const adminCreateUserApi = (data) => api.post('/auth/users/create/', data);
export const toggleUserStatusApi = (id) => api.post(`/auth/users/${id}/toggle-status/`);

// Agreement certificate — admin
export const getPublisherAgreementApi = (publisherId) =>
  api.get(`/auth/publishers/${publisherId}/agreement/`);
export const updatePublisherAgreementApi = (publisherId, formData) =>
  api.post(`/auth/publishers/${publisherId}/agreement/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

// Agreement certificate — publisher self-service
export const getMyAgreementApi = () => api.get('/auth/agreement/');
export const downloadAgreementCertificateApi = () =>
  api.get('/auth/agreement/download/', { responseType: 'blob' });

// NDA agreement — admin
export const getPublisherNDAApi = (publisherId) => api.get(`/auth/publishers/${publisherId}/nda/`);
export const updatePublisherNDAApi = (publisherId, data) => api.post(`/auth/publishers/${publisherId}/nda/`, data);

// NDA agreement — publisher self-service
export const getMyNDAApi = () => api.get('/auth/nda/');
